module.exports = __webpack_public_path__ + "static/media/digital-signage-img5.c32951be.jpg";